module.exports = __webpack_public_path__ + "img/logoAns.c2a8a727.jpeg";